import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { BrandingModel } from "../domain/Branding";
import { UpdateBrandModel } from "../domain/UpdateBrand";
import { APP_CONFIG, AppConfig } from '../app-config.module';
import { protectedResources } from '../auth-config';
import URLUtils from "../shared/Utility/urlUtils";

/** Printable ASCII with no leading or trailing space, or empty: safe to send unchanged in a header. */
const HEADER_SAFE_PASSWORD = /^(?:[!-~](?:[ -~]*[!-~])?)?$/;

export const NOTEBOOK_REQUEST_ID_HEADER = 'X-FN-Request-Id';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig,
    private httpClient: HttpClient
  ) { }

  url = protectedResources.apiBaseUrl.endpoint;

  // ===========================================================================
  //
  // ===========================================================================
  DownloadNote(noteID: string, filetype: string, password: string, packageType: string, userID: string): Observable<any> {

    let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

    let fullURL: string = this.url + "/api/Notes/" + noteID + "/DownloadForensicNote";
    fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

    return this.passwordProtectedDownload(fullURL, password, packageType || '', { 'Content-Type': filetype });

  }

  // // ===========================================================================
  // // DEPRECATED - OLD
  // // ===========================================================================
  // DownloadNotebook(notebookID: string, filetype: string, password: string, packageType: string): Observable<any> {

  //   console.log("filetype", filetype);
  //   console.log("password", password);
  //   console.log("packageType", packageType);

  //   let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

  //   let fullURL: string = this.url + "/api/Notebooks/" + notebookID + "/DownloadForensicNotebook";
  //   fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

  //   return this.http.get(fullURL
  //     , {
  //       responseType: 'arraybuffer', headers: new HttpHeaders({ 'Content-Type': filetype }),
  //       params: {
  //         "password": password,
  //         "packageType": packageType
  //       }, withCredentials: true
  //     }
  //   );

  // }

  // ===========================================================================
  //
  // ===========================================================================
  GenerateDownloadNotebook(notebookID: string, filetype: string, password: string, packageType: string, userID: string, requestId?: string): Observable<any> {

    console.log("filetype", filetype);
    // Removed: download password must never be logged. SECURITY-AUDIT-2026-07.md (CR-1).
    console.log("packageType", packageType);

    let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

    let fullURL: string = this.url + "/api/Notebooks/" + notebookID + "/RequestForensicNotebook";
    fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

    const requestHeaders: { [name: string]: string } = requestId ? { [NOTEBOOK_REQUEST_ID_HEADER]: requestId } : {};
    return this.passwordProtectedDownload(fullURL, password, String(packageType || '0'), requestHeaders);

  }


//   async DownloadNotebook(generationID: string, filetype: string): Promise<ArrayBuffer> {
//     const httpPostOptions =
//     {
//       withCredentials: true
//     }

//     let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

//     let fullURL: string = this.url + "/api/Notebooks/DownloadNotebook/" + generationID;
//     // fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

//     console.log("filetype", filetype);
//     // return this.http.get<any>(fullURL, httpPostOptions);

//     return await this.http.post(fullURL, httpPostOptions, {
//       responseType: "arraybuffer",
//     }).pipe(map((file: ArrayBuffer) => {
//       return file;
//     })).toPromise
//   }




// }

  // DownloadNotebook(generationID: string, filetype: string){

  //   let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

  //   let fullURL: string = this.url + "/api/Notebooks/DownloadNotebook/" + generationID;
  //   fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

  //   console.log("filetype", filetype);


  //   return this.http.get(fullURL
  //     , {
  //       responseType: 'arraybuffer', headers: new HttpHeaders({ 'Content-Type': filetype }),
  //       withCredentials: true
  //     }
  //   );
  // }

  DownloadNotebook(generationID: string, filetype: string, userID: string){

    let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

    let fullURL: string = this.url + "/api/Notebooks/DownloadNotebook/" + generationID;
    fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

    console.log("filetype", filetype);


    return this.http.get(fullURL
      , {
        responseType: 'blob', headers: new HttpHeaders({ 'Content-Type': filetype }),
        withCredentials: true
      }
    );
  }



  // ===========================================================================
  //
  // ===========================================================================
  DownloadAttachment(fileID: string, userID: string): Observable<any> {


    let enableServiceWorkerCache: boolean = true;  // NEVER Save PDF to CACHE - No Reason

    let fullURL: string = this.url + "/api/Attachments/DownloadAttachment/" + fileID;
    fullURL = URLUtils.setURLCachingParam(fullURL, enableServiceWorkerCache, userID);

    return this.http.get(fullURL
      , {
        responseType: 'arraybuffer', headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
        withCredentials: true
      }
    );

  }

  // ===========================================================================
  // The download password never goes in the URL: Azure Front Door and the App
  // Service access log record every query string. It travels in the
  // X-FN-Download-Password header, which the API reads since NotesApplication
  // PR 66 (e47223a2). A header cannot carry every password unchanged: browsers
  // refuse values outside ISO-8859-1, Kestrel rejects non-ASCII header bytes,
  // and HTTP trims leading and trailing spaces. Any password that is not plain
  // printable ASCII without edge spaces is sent as a POST form field
  // (passwordForm) instead, which the same API version also accepts.
  // Requires that API in production BEFORE this frontend ships (prod 4e7ecaad
  // reads only ?password=).
  // ===========================================================================
  private passwordProtectedDownload(fullURL: string, password: string, packageType: string, extraHeaders: { [name: string]: string }): Observable<ArrayBuffer> {
    const value = password || '';
    const params = { packageType };

    if (HEADER_SAFE_PASSWORD.test(value)) {
      return this.http.get(fullURL, {
        responseType: 'arraybuffer',
        withCredentials: true,
        headers: new HttpHeaders({ ...extraHeaders, 'X-FN-Download-Password': value }),
        params,
      });
    }

    // encodeURIComponent, not HttpParams: Angular's codec leaves '=', ';' and others unescaped.
    return this.http.post(fullURL, 'passwordForm=' + encodeURIComponent(value), {
      responseType: 'arraybuffer',
      withCredentials: true,
      headers: new HttpHeaders({ ...extraHeaders, 'Content-Type': 'application/x-www-form-urlencoded' }),
      params,
    });
  }
}
